import React from 'react';
import { Form } from 'react-bootstrap';

type ItemProps = {
  item: string; // Adjust this type to match the shape of the items you're rendering
  onChange: (item: string) => void;
  /** Optional label for form controls. */
  label?: string;
};

const FormInputComponent = ({ item, onChange, label }: ItemProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value); // Call onChange with the updated value
  };

  return (
    <div>
      {label && <label htmlFor="">{label}</label>}
      <Form.Control value={item} onChange={handleInputChange} />
    </div>
  );
};

export default FormInputComponent;
